import {
    GET_LOADPARAMS_FORMS, GET_OFFERED_COURSES, GET_REGISTERED_COURSES,
    GET_DISPLAYED_REGISTERED_COURSES,
    GET_WAITINGLIST,
    GET_TRANSCRIPT_TABLE,
    GET_DROPPED_TABLE,
    GET_REGISTERED_TEMP_COURSES,
    GET_UNOFFICIAL_WAITINGLIST,
    DELETE_UNOFFICIAL_WAITINGLIST,
    DROPPED_UNOFFICIAL_COURSES,
    SET_WAITING_DATA_FETCHED,
    SET_REGISTER_SEMAPHORE_SUCCESSFULLY,
    SET_REGISTER_SEMAPHORE_REQUEST,
    SET_REGISTER_SEMAPHORE_ERROR,
    RESET_REGISTER_SEMAPHORE_SUCCESSFULLY,
    RESET_REGISTER_SEMAPHORE_REQUEST,
    RESET_REGISTER_SEMAPHORE_ERROR
} from './types'

const initialState = {
    loadParameter: {
    },
    offeredCourses: [],
    registerCourses: [],
    displayedRegisteredCourses: [],
    waitingListTable: [],
    transcriptTable: [],
    droppedTable: [],
    registeredArray: [],
    waitingUnofficialArray: [],
    droppedUnofficialCourse: [],
    waitingListDataFetched: false,
    isLoadingRequest: false,
    semaphoreCreated: false
};

const unofficialReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case GET_LOADPARAMS_FORMS:
            return {
                ...state,
                loadParameter: { ...payload }
            };
        case DROPPED_UNOFFICIAL_COURSES:
            return {
                ...state,
                droppedUnofficialCourse: [...payload]
            };
        case GET_OFFERED_COURSES:
            return {
                ...state,
                offeredCourses: [...payload]
            };
        case GET_REGISTERED_COURSES:
            return {
                ...state,
                registerCourses: [...payload]
            };
        case GET_DISPLAYED_REGISTERED_COURSES:
            return {
                ...state,
                displayedRegisteredCourses: [...payload]
            };
        case GET_WAITINGLIST:
            return {
                ...state,
                waitingListTable: [...payload]
            };
        case GET_TRANSCRIPT_TABLE:
            return {
                ...state,
                transcriptTable: [...payload]
            };
        case GET_DROPPED_TABLE:
            return {
                ...state,
                droppedTable: [...payload]
            };
        case GET_REGISTERED_TEMP_COURSES:
            return {
                ...state,
                registeredArray: [...payload]
            };
        case GET_UNOFFICIAL_WAITINGLIST:
            return {
                ...state,
                waitingUnofficialArray: [...payload] 
            };
        case DELETE_UNOFFICIAL_WAITINGLIST:
            return {
                ...state,
                waitingUnofficialArray: state.waitingUnofficialArray.filter((item, ind) =>
                    payload[0].indexOf(ind.toString()) == -1
                )
            }
        case SET_WAITING_DATA_FETCHED:
            return {
                ...state,
                waitingListDataFetched: payload
            }
        case SET_REGISTER_SEMAPHORE_REQUEST:
            return {
                ...state,
                isLoadingRequest: true,
            }
        case SET_REGISTER_SEMAPHORE_SUCCESSFULLY:
            return {
                ...state,
                isLoadingRequest: false,
                semaphoreCreated: {...payload}
            }
        case RESET_REGISTER_SEMAPHORE_REQUEST:
            return {
                ...state,
                isLoadingRequest: true,
            }
        case RESET_REGISTER_SEMAPHORE_SUCCESSFULLY:
            return {
                ...state,
                isLoadingRequest: false,
                semaphoreCreated: null
            }
        case RESET_REGISTER_SEMAPHORE_ERROR: 
        case SET_REGISTER_SEMAPHORE_ERROR: 
        default:
            return state;
    }
};

export default unofficialReducer;